module.exports = __webpack_public_path__ + "static/media/BuzzfeedNews.ce97d26f.png";